import classNames from 'classnames';
import {LucideIcon} from 'lucide-react';
import * as React from 'react';

export type BadgeVariant = 'neutral' | 'brand';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: BadgeVariant;
    icon?: LucideIcon;
}

const variantClasses: Record<BadgeVariant, string> = {
    neutral: 'mp-badge--neutral',
    brand: 'mp-badge--brand',
};

export const Badge: React.FunctionComponent<BadgeProps> = ({variant = 'neutral', icon: Icon, className, children, ...rest}: BadgeProps) => (
    <span className={classNames('mp-badge', variantClasses[variant], className)} {...rest}>
        {Icon && <Icon size={16}/>}
        {children}
    </span>
);
